<app-navbar></app-navbar>
<div class="content">
  <div class="page-header">
    <h2 itemprop="headline">
      DATA PROTECTION NOTICE <br />
      Effective Date: September 2023
    </h2>
  </div>
  <div itemprop="articleBody">
    <span style="color: #686868"><b>Introduction</b></span>

    <p>
      This data protection notice outlines how <b>HuiosPay</b> collects, uses,
      and protects personal information. We are committed to ensuring that your
      privacy is protected, in compliance with the Nigeria Data Protection
      Regulation (NDPR) and other applicable data protection laws.
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Data Collected</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We may collect the following types of personal information.</span
      >
    </p>

    <ol style="text-align: justify; list-style-type: lower-alpha">
      <li>
        Identity Information: <br />
        <span class="color1">
          Includes your name, contact details, and identification documents.
        </span>
      </li>
      <li>
        Financial Information: <br />
        <span class="color1">
          Includes details related to financial transactions conducted on our
          platform.
        </span>
      </li>
      <li>
        Device Information: <br />
        <span class="color1">
          Includes information about the device you use to access our services.
        </span>
      </li>
      <li>
        Usage Information: <br />
        <span class="color1">
          Includes data about your interactions with our platform.
        </span>
      </li>
      <li>Other information relevant to customer surveys or offers. <br /></li>
    </ol>

    <!-- <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Data Security Measures</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We implement appropriate technical and organizational measures to
        ensure the security and confidentiality of your personal data.
      </span>
    </p> -->

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>How we collect data</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We collect personal information in the following ways:
      </span>
    </p>

    <ul style="text-align: justify">
      <li>
        <span style="color: #686868"
          >Directly from individuals when they provide information to us
          and</span
        >
      </li>
      <li>
        <span style="color: #686868"
          >automatically when individuals use our website or services (e.g.,
          through cookies)
        </span>
      </li>
    </ul>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>How We Use Your Personal Data</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We use your personal data for purposes including but not limited to
        account management, service delivery, and compliance with legal
        obligations.</span
      >
    </p>
    <!-- <ul style="text-align: justify">
      <li>
        <span style="color: #686868"
          >Providing and improving our products and services.</span
        >
      </li>
      <li>
        <span style="color: #686868"
          >Responding to enquiries and providing customer support.
        </span>
      </li>

      <li>
        <span style="color: #686868">internal record keeping. </span>
      </li>

      <li>
        <span style="color: #686868"
          >marketing and promotional activities with your consent.
        </span>
      </li>
    </ul> -->

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Purpose of Data Processing</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We process personal information for the following purposes.
      </span>
    </p>

    <ul style="text-align: justify">
      <li>
        <span style="color: #686868"
          >Providing and improving our products and services.</span
        >
      </li>
      <li>
        <span style="color: #686868"
          >Responding to inquiries and providing customer support.
        </span>
      </li>
      <li>
        <span style="color: #686868">Internal record keeping. </span>
      </li>
      <li>
        <span style="color: #686868"
          >Marketing and promotional activities with your consent.
        </span>
      </li>
    </ul>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Legal Basis for Processing</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We do not sell, trade, or transfer personal information to external
        parties unless we have obtained consent or are required by law to do so.
        We process personal data based on legal grounds such as the necessity
        for the performance of a contract, and compliance with legal
        obligations.</span
      >
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Data Security Measures</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We implement appropriate technical and organizational measures to
        ensure the security and confidentiality of your personal data.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Third Party Disclosures</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        We may share your personal data with third-party service providers of
        the purpose of providing and improving our services. For more
        information,please refer to our
        <a href="privacy-policy">Privacy Policy.</a>
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Your Rights</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">You have the right to: </span>
    </p>

    <ul style="text-align: justify">
      <li>
        <span style="color: #686868"
          >Request access to the personal information we hold about you.
        </span>
      </li>
      <li>
        <span style="color: #686868"
          >Correct any inaccuracies in your personal information.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          >Withdraw consent from processing personal information (where
          applicable)
        </span>
      </li>

      <li>
        <span style="color: #686868"
          >Request the deletion of your personal information.
        </span>
      </li>
    </ul>

    <!-- <p style="text-align: justify" align="justify"></p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Contact Information</b></span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >WIf you have any questions or concerns about our data protection
        services, please contact us at
        <a href="mailto:contactus@huiospay.com">contactus@huiospay.com</a> or
        <a href="tel:08096247247">08096247247</a>.</span
      >
    </p> -->

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        ><b>Cookies and Similar Technologies</b></span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We use cookies and similar technologies. For more information, please
        refer to our <a href="cookies-policy">Cookies Policy</a>.
      </span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Data Retention</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We retain your personal data for as long as necessary to fulfil the
        purposes outlined in this notice or as required by law.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Changes to this Notice</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We may update this data protection notice from time to time. Please
        check this page for the latest version.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Compliance with NDPR</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >We adhere to the Nigeria Data Protection Regulation and other
        applicable data protection laws.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Contact Information</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >If you have any questions or concerns about our data protection
        services, please contact us at <a href="mailto:contactus@huiospay.com"> contactus@huiospay.com</a> or <a href="tel:+2348037086670">+234 (0)
        8037086670</a> | <a href="tel:+2348096247247"> (0) 8096247247.</a>
      </span>
    </p>

    <p><b>Date of last update: </b>September 2023</p>

    <p align="justify"></p>

    <p align="justify" style="margin-bottom: 100px">
      <span style="color: #686868"> </span>
    </p>
  </div>
</div>
<app-footer></app-footer>
